import React, { useEffect, useState } from 'react';

export default function Toast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (ev) => {
      try {
        const detail = ev && ev.detail ? ev.detail : { message: String(ev) };
        const id = Date.now() + Math.random();
        setToasts((t) => [...t, { id, ...detail }]);
        // auto-remove after 4s
        setTimeout(() => setToasts((t) => t.filter(x => x.id !== id)), 4200);
      } catch (e) { /* ignore */ }
    };

    window.addEventListener('app-toast', handler);
    return () => window.removeEventListener('app-toast', handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{ position: 'fixed', right: 18, top: 18, zIndex: 14000, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {toasts.map(t => (
        <div key={t.id} style={{ minWidth: 220, maxWidth: 420, padding: '10px 14px', borderRadius: 10, background: t.type === 'error' ? 'linear-gradient(90deg,#ffb4b4,#ff7a7a)' : (t.type === 'warn' ? 'linear-gradient(90deg,#ffdca1,#ffb86b)' : 'linear-gradient(90deg,#bbf7d0,#86efac)'), color: '#06201a', boxShadow: '0 8px 30px rgba(2,6,23,0.6)', fontWeight: 700 }}>
          <div style={{ fontSize: 13 }}>{t.message}</div>
          {t.detail && <div style={{ fontSize: 12, marginTop: 6, opacity: 0.9, fontWeight: 500 }}>{String(t.detail)}</div>}
        </div>
      ))}
    </div>
  );
}
